<template>
  <div class="custom-motif popup">
      <div :class="['popup-content', {'working': isTyping }]">
          <img :data-test="this.createdMotif.motifImageData"
               :src="
          this.createdMotif.motifImageData
            ? 'data:image/png;base64,' + this.createdMotif.motifImageData
            : this.createdMotif.motifUrl
        " /><br /><br />
          <Transition>
              <div v-if="this.error" class="error">{{this.error}}</div>
          </Transition>
          <div class="custom-motif-line1 load-working form-inputs">
              <input v-model="cmInputs[0].text1"
                     placeholder="Enter Text Here"
                     text="ABC"
                     v-on:input="debounceInput"  onFocus="this.select();" />
              <input style="display:none;"
                     v-model="cmInputs[0].font1"

                     placeholder="Enter Font Here"  />
          </div>

          <div v-if="this.motif.hasTwoLines()" class="custom-motif-line2 form-inputs">
              <input v-model="cmInputs[1].text1"
                     placeholder="Enter Text Here"
                     text="XYZ"
                     v-on:input="debounceInput"  onFocus="this.select();" />

              <input style="display: none"
                     v-model="cmInputs[1].font1"
                     placeholder="Enter Font Here" />
          </div>

          <PaletteColors ref="paletteColors"
                         :flossId="cmInputs[0].flossId"
                         @change-color="setColor" />
          <div class="form-buttons">
              <a v-on:click="closeCustomMotif">Cancel</a>
              <a v-on:click="addMotif" class="load-working">
                  {{
          this.pm ? "Update Motif" : "Add Motif"
                  }}
              </a>
          </div>
      </div>

    <div class="overlay" @click="closeCustomMotif"></div>
  </div>
</template>

<script>
import PaletteColors from "@/components/PaletteColors.vue";
import CustomMotifInput from "@/objects/CustomMotifInput.js";
import CustomMotifRequest from "@/objects/CustomMotifRequest.js";
import MotifData from "@/objects/MotifData.js";
import CustomMotifService from "@/services/CustomMotifService.js";
import Globals from "@/globals.js";
import { mapState } from "vuex";







export default {
        name: "CustomMotif",
        props: ["motif", "pm"],
  computed: {
      ...mapState(["productMotifs"])
  },
  data() {
    return {
        cmInputs: null,
        error: null,
        createdMotif: this.motif,
        edit: false,
        currentImageSrc: this.motif.motifImageData,
        timeout: null,
        debounce: null,
        isTyping: false,
        productType: Globals.getProductType(),
        //maxWidth1: (Globals.getProductType()==7 ? 4 : 20)
    };
  },
        methods: {
            debounceInput(event) {
                //is typing
                this.isTyping = true;
                clearTimeout(this.debounce)
                this.debounce = setTimeout(() => {

                    this.isTyping = false;
                    this.createMotif();

                    //stopped typing
                    //event.target.value;
                }, 600)
            },

      createMotif: function () {
          var noData = false;
          for (let i = 0; i < this.cmInputs.length; i++) {
              if (this.cmInputs[i].text1=="") {
                 noData = true;
              }
          }
          if (!noData) {
              let motifType = this.motif.motifType;
              let cmRequest = new CustomMotifRequest(motifType, this.cmInputs);
              CustomMotifService.getCustomMotif(cmRequest).then((cm) => {

                  this.createdMotif = new MotifData(cm.data);

                 this.createdMotif.motifId = this.motif.motifId;

              });
              this.error = null;
          }
      
      },
      addMotif() {
          var noData = false;
          for (let i = 0; i < this.cmInputs.length; i++) {
              if (this.cmInputs[i].text1 == "") {
                  noData = true;
              }
          }
          if (!noData) {
              //this.$store.dispatch("setLoadingStatus", "Creating Motif");
              let existingMotifWidth = this.pm ? this.pm.motifData.motifWidth : 0;
              if (this.checkWidth(this.createdMotif, existingMotifWidth)) {
                  this.$nextTick(() => {
                      if (this.pm) {
                          this.pm.motifData = this.createdMotif;
                          this.pm.customMotifInputs = this.cmInputs;
                          this.$emit("reset-customizing-motif");
                      } else {
                          this.$emit("add-custom-motif", this.createdMotif, this.cmInputs);
                      }
                  });
              }
          } else {
              this.error="Please enter your text."
          }
      },
    setColor(pcId, pcHex) {
      this.cmInputs[0].color1 = "#" + pcHex;
      this.cmInputs[0].flossId = pcId;
      if (this.cmInputs.length == 2) {
        this.cmInputs[1].color1 = "#" + pcHex;
        this.cmInputs[1].flossId = pcId;
        }
        this.createMotif();
    },
    closeCustomMotif: function () {
      this.$emit("reset-customizing-motif");
    },
    checkWidth(motif, existingWidth) {
      let hasSpace = Globals.checkWidth(
        this.$store,
        null,
        motif,
        existingWidth
      );

      if (hasSpace) {
        return true;
      } else {
        this.$emit("alert-width", motif);
        return false;
      }
    },
  },
  components: { PaletteColors },
  created() {
    this.cmInputs = [];
      //console.log("created");
    let initInput = new CustomMotifInput();
      initInput.font1 = this.motif.motifFont ? this.motif.motifFont
          : this.pm.customMotifInputs[0].font1;
      //console.log(initInput.font1);
      //console.log(this.motif);
      initInput.fontSize1 = this.motif.motifFontSize ? this.motif.motifFontSize
          : this.pm ? this.pm.customMotifInputs[0].fontSize1 : null ;
      
      //console.log(initInput.font1);
      initInput.text1 = this.pm ? this.pm.customMotifInputs[0].text1 : "";
      //console.log(initInput.text1);
    initInput.flossId = this.pm
      ? this.pm.customMotifInputs[0].flossId
          : this.motif.motifFlossId;
      //console.log(initInput.flossId);
      this.cmInputs.push(initInput);
      

    if (this.motif.hasTwoLines()) {
        initInput = new CustomMotifInput();
        initInput.font1 = this.motif.motifFont ? this.motif.motifFont
            : this.pm.customMotifInputs[0].font1;
        initInput.fontSize1 = this.motif.motifFontSize;
      initInput.text1 = this.pm ? this.pm.customMotifInputs[1].text1 : "";
      initInput.flossId = this.pm
        ? this.pm.customMotifInputs[1].flossId
        : this.motif.motifFlossId;
        this.cmInputs.push(initInput);
        
      }
      //console.log(this.cmInputs);
  },
  updated() {},
  mounted() {},
};
</script>

<style>
.custom-motif input {
  line-height: 2em;
  text-align: center;
  text-transform:uppercase;
  font-size: 1em;
}
.custom-motif img {
  height: 2em;
  -ms-interpolation-mode: nearest-neighbor;
  image-rendering: -moz-crisp-edges;
  image-rendering: pixelated;
  filter: drop-shadow(1px 1px 1px #666);
}

    .custom-motif-line2 {
        margin-top:1em;
    }
    .error {
        color: #db3e38;
        margin-bottom: 1em;
    }
    .v-enter-active,
    .v-leave-active {
        transition: opacity 0.5s ease;
    }

    .v-enter-from,
    .v-leave-to {
        transition: opacity 0.5s ease;
        opacity: 0;
    }
    img {
        transition: opacity 1s;
    }
    .working img {
        opacity:.4;
        transition:1s;
    }

    .load-working {
        position: relative;
        transition:1s;
    }
    .working .form-buttons .load-working {
        background-color:#ccc;
        pointer-events:none;
        
    }

        .working .form-inputs.load-working:before {
            left:calc(50% - 1em);
            top:-3.5em;
        }

    .working .form-buttons .load-working:before {
        left: .25em;
        top: calc(50% - 1em);
    }

        .working .load-working:before {
            font-size: 1em;
            border-radius: 50%;
            width: 2em;
            height: 2em;
            content: "";
            position: absolute;
            text-indent: -9999em;
            border-top: .25em solid rgba(123, 123, 123, 0.2);
            border-right: .25em solid rgba(123, 123, 123, 0.2);
            border-bottom: .25em solid rgba(123, 123, 123, 0.2);
            border-left: .25em solid rgba(123, 123, 123, 1);
            -webkit-transform: translateZ(0);
            -ms-transform: translateZ(0);
            transform: translateZ(0);
            -webkit-animation: load8 1.1s infinite linear;
            animation: load8 1.1s infinite linear;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
        }

    @-webkit-keyframes load8 {
        0% {
            -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
        }

        100% {
            -webkit-transform: rotate(360deg);
            transform: rotate(360deg);
        }
    }

    @keyframes load8 {
        0% {
            -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
        }

        100% {
            -webkit-transform: rotate(360deg);
            transform: rotate(360deg);
        }
    }

</style>
